const pageNameKey = "otaDrawerInfo";

export const otaDrawerInfoEn = {
  [pageNameKey]: {
    providedForText: "Provided for",
    machineText: "Machine",
    uploaderText: "Uploader",
    buildingAltText: "Building",
    uploaderAltText: "User",
  },
};

export const otaDrawerInfoPtBr = {
  [pageNameKey]: {
    providedForText: "Fornecido para",
    machineText: "Máquina",
    uploaderText: "Enviador",
    buildingAltText: "Construção",
    uploaderAltText: "Usuário",
  },
};

export const otaDrawerInfoDe = {
  [pageNameKey]: {
    providedForText: "Vorgesehen",
    machineText: "Maschine",
    uploaderText: "Uploader",
    buildingAltText: "Gebäude",
    uploaderAltText: "Benutzer",
  },
};

export const otaDrawerInfoZhHans = {
  [pageNameKey]: {
    providedForText: "提供给",
    machineText: "机器",
    uploaderText: "上传者",
    buildingAltText: "建筑",
    uploaderAltText: "用户",
  },
};

export const otaDrawerInfoIt = {
  [pageNameKey]: {
    providedForText: "Fornito per",
    machineText: "Macchina",
    uploaderText: "Caricato da",
    buildingAltText: "Edificio",
    uploaderAltText: "Utente",
  },
};

export const otaDrawerInfoEs = {
  [pageNameKey]: {
    providedForText: "Proporcionado por",
    machineText: "Máquina",
    uploaderText: "Subido por",
    buildingAltText: "Edificio",
    uploaderAltText: "Usuario",
  },
};

export const otaDrawerInfoNl = {
  [pageNameKey]: {
    buildingAltText: "Gebouw",
    machineText: "Machine",
    providedForText: "Bestemming",
    uploaderAltText: "Gebruiker",
    uploaderText: "Uploader",
  },
};

export const otaDrawerInfoTr = {
  [pageNameKey]: {
    buildingAltText: "Bina",
    machineText: "Makine",
    providedForText: "için sağlanmıştır",
    uploaderAltText: "Kullanıcı",
    uploaderText: "Yükleyici",
  },
};
